import React, { useState, useEffect, useRef } from 'react';
import { RiArrowRightSLine } from 'react-icons/ri';
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import van from '../../assets/svg/Van.svg';
import noteIcon from '../../assets/svg/note-1-svgrepo-com 1.svg';
import './CheckingTools.css';

  const CheckingCars = () => {
  
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  // States
  const [carInspectionList, setCarInspectionList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAlreadyChecked, setIsAlreadyChecked] = useState(false);
  const [vehicleInfo, setVehicleInfo] = useState(null);
  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [itemDetails, setItemDetails] = useState({});

  const BASE_URL = "https://estbn.com/EstbnNew/public/api/";
  const token = localStorage.getItem("token");
  const SHIFT_ID = localStorage.getItem("active_shift_id");

  useEffect(() => {
  const initializeData = async () => {
    if (!token || !SHIFT_ID) {
      console.log("Missing token or SHIFT_ID");
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const checkResponse = await axios.get(
        `${BASE_URL}stuff/get-vehicle-checks/${SHIFT_ID}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      console.log("Vehicle Checks Response:", checkResponse.data);
   if (
     checkResponse.data.success &&
     checkResponse.data.data?.data?.length > 0
   ) {
     const checkData = checkResponse.data.data.data[0];
  setIsAlreadyChecked(true);
  setVehicleInfo(checkData.vehicle);

  const existingChecks = {};
  const existingDetails = {};
    const mappedList = checkData.checklist.map((itemObj) => {
      existingChecks[itemObj.item_id] =
        itemObj.is_checked === "passed" ? "ready" : "not-ready";

      existingDetails[itemObj.item_id] = {
        notes: itemObj.notes || "",
        file: null,
        image_path: itemObj.image_path || null,
      };

      return itemObj.item;
    });
    setCarInspectionList(mappedList);
    setSelectedStatus(existingChecks);
    setItemDetails(existingDetails);
   } else {
     setIsAlreadyChecked(false);
     await loadChecklistItems();
   }
    } catch (error) {
      if (error.response?.status === 404) {
        console.log("No vehicle checks found. Loading checklist items...");
        setIsAlreadyChecked(false);
        await loadChecklistItems();
      } else {
        console.log("Unexpected Error:", error);
        toast.error("حدث خطأ في جلب البيانات" , {autoClose: 3000});
      }
    } finally {
      setLoading(false);
    }
  };

  const loadChecklistItems = async () => {
    try {
      const itemsResponse = await axios.get(
        `${BASE_URL}stuff/getItems`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      console.log("Checklist Items:", itemsResponse.data);

      if (itemsResponse.data.success) {
        setCarInspectionList(itemsResponse.data.data.data);
      }
    } catch (err) {
      console.log("Checklist Load Error:", err);
      toast.error("فشل تحميل عناصر الفحص" , {autoClose: 3000});
    }
  };

  initializeData();
  }, [token, SHIFT_ID]);
  
  const handleOpenModal = (item) => {
    setActiveItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActiveItem(null);
  };

  const handleSaveDetails = () => {
    toast.success("تم حفظ التفاصيل");
    handleCloseModal();
  };

  const handleDetailChange = (field, value) => {
    setItemDetails(prev => ({
      ...prev,
      [activeItem.id]: {
        ...(prev[activeItem.id] || { notes: '', file: null }),
        [field]: value
      }
    }));
  };

  const handleCheck = (id, status) => {
    if (isAlreadyChecked) return;
    setSelectedStatus(prev => ({
      ...prev,
      [id]: prev[id] === status ? null : status
    }));
  };

  const handleSubmit = async () => {
    if (Object.keys(selectedStatus).length < carInspectionList.length) {
      toast.warning("يرجى فحص جميع الأجزاء قبل الحفظ");
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    carInspectionList.forEach((item, index) => {
      formData.append(`items[${index}][item_id]`, item.id);
      formData.append(`items[${index}][is_checked]`, selectedStatus[item.id] === 'ready' ? 'passed' : 'failed');
      if (itemDetails[item.id]?.notes) formData.append(`items[${index}][notes]`, itemDetails[item.id].notes);
       if (itemDetails[item.id]?.file) {
         formData.append(`items[${index}][image]`, itemDetails[item.id].file);
       }
    });

    try {
      const response = await axios.post(`${BASE_URL}stuff/vehicle-checks`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.success) {
        toast.success("تم حفظ الفحص بنجاح");
        setIsAlreadyChecked(true);
      }
    } catch (error) {
      toast.error("فشل حفظ الفحص");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Calculations for Summary
  const readyCount = Object.values(selectedStatus).filter(s => s === 'ready').length;
  const faultyCount = Object.values(selectedStatus).filter(s => s === 'not-ready').length;
  const totalChecked = Object.keys(selectedStatus).length;
  const hasExistingImage = itemDetails[activeItem?.id]?.image_path;
    
  if (loading) return <div className="text-center p-5">جاري التحميل...</div>;

  return (
    <div className="inspection-page" dir="rtl">
      <div className="top-nav px-4 pt-3 d-flex align-items-center gap-2">
        <span
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer", color: "#888" }}
        >
          العمليات
        </span>
        <RiArrowRightSLine style={{ color: "#888" }} />
        <span style={{ fontWeight: "bold" }}>
          {isAlreadyChecked ? "تفاصيل فحص المركبة" : "فحص مركبة جديد"}
        </span>
      </div>
      <div className="container-fluid py-4">
        {/* Vehicle Info Card */}
        <div className="vehicle-info-card shadow-sm mb-4 d-flex justify-content-between align-items-center p-3 bg-white rounded-4">
          <div className="vehicle-details text-end">
            <h4 className="fw-bold">{vehicleInfo?.name || "نيسان فانيت"}</h4>
            <p className="mb-1 text-muted">
              الموديل: {vehicleInfo?.year || "2021"}
            </p>
            <p className="mb-0 text-muted">
              رقم اللوحة: {vehicleInfo?.plate_number || "س ل ط ٥٣٢٤"}
            </p>
          </div>
          <div className="vehicle-image">
            <img src={van} alt="van" width="120" />
          </div>
        </div>
        <div className="row g-4">
          {/* LEFT SIDE: Checklist */}
          <div className="col-md-7 order-md-1">
            <div
              className={`checklist-card shadow-sm p-4 bg-white rounded-4 ${isAlreadyChecked ? "readonly-mode" : ""}`}
            >
              <div className="d-flex justify-content-start mb-3">
                <span className="fw-bold text-muted">سليم</span>
                <span className="fw-bold text-muted px-2">عطل</span>
              </div>

              <div className="items-list d-flex flex-column gap-3">
                {carInspectionList.map((item) => (
                  <div
                    className="check-row d-flex align-items-center justify-content-between py-2 border-bottom"
                    key={item.id}
                  >
                    <div className="d-flex gap-3">
                      <div
                        className={`custom-checkbox ready ${selectedStatus[item.id] === "ready" ? "active" : ""}`}
                        onClick={() => handleCheck(item.id, "ready")}
                      >
                        {selectedStatus[item.id] === "ready" && (
                          <i className="bi bi-check"></i>
                        )}
                      </div>
                      <div
                        className={`custom-checkbox fault ${selectedStatus[item.id] === "not-ready" ? "active" : ""}`}
                        onClick={() => handleCheck(item.id, "not-ready")}
                      >
                        {selectedStatus[item.id] === "not-ready" && (
                          <i className="bi bi-x"></i>
                        )}
                      </div>
                      <span className="fw-medium">{item.name_ar}</span>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <div
                        className="note-wrapper"
                        onClick={() => handleOpenModal(item)}
                      >
                        <img
                          src={noteIcon}
                          alt="note"
                          style={{
                            width: "24px",
                            cursor: "pointer",
                            filter:
                              itemDetails[item.id]?.notes ||
                              itemDetails[item.id]?.file ||
                              itemDetails[item.id]?.image_path
                                ? "none"
                                : "grayscale(100%) opacity(0.4)",
                          }}
                        />

                        {(itemDetails[item.id]?.notes ||
                          itemDetails[item.id]?.file ||
                          itemDetails[item.id]?.image_path) && (
                          <span className="note-dot"></span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* RIGHT SIDE: Summary Card (Matching your 2nd image) */}
          <div className="col-md-5 order-md-2">
            <div className="summary-card shadow-sm p-4 bg-white rounded-4 h-100">
              <div className="d-flex justify-content-between align-items-start mb-4">
                <h5 className="fw-bold text-secondary m-0">ملخص الفحص</h5>
                <span className="text-muted small">
                  تم فحص {totalChecked} من {carInspectionList.length} اجزاء
                </span>
              </div>

              <div className="summary-list d-flex flex-column justify-content-end gap-3">
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <div className="summary-icon-box green">
                    <i className="bi bi-check"></i>
                  </div>
                  <span className="fw-bold">{readyCount} سليم</span>
                </div>
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <div className="summary-icon-box red">
                    <i className="bi bi-x"></i>
                  </div>
                  <span className="fw-bold">{faultyCount} به عطل</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isAlreadyChecked && (
          <div className="text-center mt-5">
            <button
              className="btn-save-main px-5 py-3"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "جاري الحفظ..." : "حفظ الفحص"}
            </button>
          </div>
        )}
      </div>
      {/* Details Modal (Matching your 1st image) */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        className="details-modal"
        dir="rtl"
      >
        <Modal.Body className="p-4 text-end">
          <h5 className="text-center fw-bold mb-4">اضافة تفاصيل للفحص</h5>

          <label className="mb-2 d-block small fw-semibold">
            اكتب ملاحظة أو ارفع صورة للجزء في حالة وجود مشكله
          </label>
          <textarea
            className="form-control mb-4 rounded-3 p-3 bg-light border-0"
            placeholder="اكتب أي ملاحظات عن هذا الجزء..."
            rows="2"
            value={itemDetails[activeItem?.id]?.notes || ""}
            onChange={(e) => handleDetailChange("notes", e.target.value)}
          ></textarea>

          <label className="mb-2 d-block small fw-semibold">
            ارفع صورة توضح حالة الجزء
          </label>

          {hasExistingImage ? (
            <div className="text-center mt-3">
              <img
                src={`https://estbn.com/EstbnNew/public/storage/${itemDetails[activeItem?.id]?.image_path}`}
                alt="uploaded"
                style={{
                  width: "180px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
            </div>
          ) : (
            <div
              className="upload-container text-center p-4 rounded-3 w-100 d-flex flex-column"
              onClick={() => fileInputRef.current.click()}
            >
              <input
                type="file"
                ref={fileInputRef}
                hidden
                onChange={(e) => handleDetailChange("file", e.target.files[0])}
              />

              <div className="upload-icon mb-2">
                <i className="bi bi-file-earmark-arrow-up fs-2 text-muted"></i>
              </div>

              <p className="mb-0 fw-bold">اضف ملف</p>
              <p className="text-muted small mb-0">
                أرفق صورة، فيديو، أو تسجيل صوتي.
              </p>

              {itemDetails[activeItem?.id]?.file && (
                <div className="text-success small mt-2">
                  تم اختيار: {itemDetails[activeItem?.id]?.file.name}
                </div>
              )}
            </div>
          )}
          {!hasExistingImage && (
            <button
              className="btn-modal-save w-100 mt-4 py-3 text-white fw-bold rounded-3"
              onClick={handleSaveDetails}
            >
              حفظ الفحص
            </button>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CheckingCars;